export class RequestEndorseSubject {
  solicitud: number;
  consecutivo: number;
  semestre: String;
  codigoMateria: String;
  nombreMateria: String;
  consecutivoMateria: number;
  codigoMateriaReconocida: String;
  nombreMateriaReconocida: String;
  nota: String;
  fechaEvaluacion: String;
  estadoMateria: String;
  aval: String;
  evaluador: String;
}
